import {
  createRouteRef,
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { gitLabJobsApi, hasGitLabJobs } from './api';
import { gitLabDeploymentsApi } from './deploymentsApi';
import { kargoDeploymentsApi } from './kargoDeploymentsApi';

const deployRouteRef = createRouteRef();

export const entityContent = EntityContentBlueprint.make({
  name: 'gitlab-jobs',
  params: {
    path: '/gitlab-jobs',
    title: 'CI/CD',
    filter: hasGitLabJobs,
    loader: () =>
      import('./components/GitLabJobsPage').then(m => <m.GitLabJobsPage />),
  },
});

export const deployPage = PageBlueprint.make({
  name: 'deploy',
  params: {
    path: '/deploy',
    routeRef: deployRouteRef,
    title: 'Deploy',
    icon: <CloudUploadIcon />,
    loader: () => import('./components/DeployPage').then(m => <m.DeployPage />),
  },
});

export const gitlabJobsPlugin = createFrontendPlugin({
  pluginId: 'gitlab-jobs',
  routes: {
    root: deployRouteRef,
  },
  extensions: [
    gitLabJobsApi,
    gitLabDeploymentsApi,
    kargoDeploymentsApi,
    entityContent,
    deployPage,
  ],
});
